import { FC, useEffect, useState } from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router";

import MainLayout from "@/layout/Main";
import { ThemeSelector } from "@/context";
import { ALLOW_CLIENT_LIST } from "@/constants/allowClientList";

import { advantageRoutes, advantageWhitelabelRoutes } from "./routes";

const MainRoutes: FC = () => {
  const [loading, setLoading] = useState(true);
  const [routes, setRoutes] = useState([]);

  const pathArray = window.location.pathname.split("/");
  const clientIndex = pathArray.indexOf("client");
  const client = pathArray[clientIndex + 1];

  useEffect(() => {
    if (client && ALLOW_CLIENT_LIST.includes(client)) {
      setRoutes(advantageWhitelabelRoutes);
      setLoading(false);
    } else {
      setRoutes(advantageRoutes);
      setLoading(false);
    }
  }, [client]);

  if (loading) return null;

  return (
    <RouterRoutes location={location}>
      {routes.map(({ path, Component, pageTitle }) => (
        <Route
          key={path}
          path={path}
          element={
            <ThemeSelector>
              <MainLayout pageTitle={pageTitle}>
                <Component pageTitle={pageTitle} />
              </MainLayout>
            </ThemeSelector>
          }
        />
      ))}
      <Route path="*" element={<Navigate to="/" />} />
    </RouterRoutes>
  );
};

export default MainRoutes;
